exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#page-user-list .user-list-filters .vs__actions{\n  position:absolute;\n  right:0;\n  top:50%;\n  -webkit-transform:translateY(-58%);\n          transform:translateY(-58%)\n}", ""]);

// exports
